import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PASSPORT_ROUTES } from './Applications/Passport/passport.routes';
import { TenantOverviewComponent } from './Applications/TenantOverview/tenantoverview.component';
import { TenantComponent } from './tenant.component';
import { tenantResolver } from './resolvers';
import { TRIAL_ADMINISTRATION_ROUTES } from '@app/Tenant/Applications/FreeTrialAdministration/trial-administration.routes';
import { AIRSWEB_ROUTES } from '@app/Tenant/Applications/Airsweb/airsweb.routes';

export const TENANT_ROUTES: Routes = [
    {
        path: 'tenant/:tenantId',
        component: TenantComponent,
        children: [
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full'
            },
            {
                path: 'overview',
                component: TenantOverviewComponent,
                canActivate: []
            },
            ...TRIAL_ADMINISTRATION_ROUTES,
            ...AIRSWEB_ROUTES,
            ...PASSPORT_ROUTES,
        ],
        canActivate: [MsalGuard],
        resolve: { tenant: tenantResolver }
    }
];
